<template>
  <div>
    <navHeader></navHeader>
    <SkeletonStructureHome v-if="isDataLoaded == true" />
    <div class="container-lg mt-5" v-if="isDataLoaded != true">
      <div class="row">
        <div class="col-12 col-md-12 col-lg-8" v-if="isDaiyNotesLoading== true">
          <div class="p-3 border-right">
            <h2 class="main-title">
              <b-skeleton width="100%" v-if="isDataLoaded == true"></b-skeleton>
              {{ DailyNotesContent.title }}
            </h2>

            <p class="text-muted">Posted on {{ FormatDate(DailyNotesContent.date) }}</p>
            <b-skeleton-img
              no-aspect
              height="100px"
              v-if="isDataLoaded == true"
            ></b-skeleton-img>
            <table
              class="table table-bordered stock-reco-card"
              v-if="
                DailyNotesContent.stockRecommendation.stockSymbol != '' ||
                DailyNotesContent.stockRecommendation.entryPrice != '' ||
                DailyNotesContent.stockRecommendation.targetPrice != '' ||
                DailyNotesContent.stockRecommendation.potentialUpside != ''
              "
            >
              <thead class="stock-reco-header">
                <tr>
                  <th colspan="4" class="text-center">Stock Recommendations</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-center">
                    Stock
                    <h4 class="stock-label">
                      {{ DailyNotesContent.stockRecommendation.stockSymbol }}
                    </h4>
                  </td>
                  <td class="text-center">
                    Entry Price
                    <h4 class="stock-label">
                      {{ DailyNotesContent.stockRecommendation.entryPrice }}
                    </h4>
                  </td>
                  <td class="text-center">
                    Target Price
                    <h4 class="stock-label">
                      {{ DailyNotesContent.stockRecommendation.targetPrice }}
                    </h4>
                  </td>
                  <td class="text-center">
                    Potential Upside
                    <h4 class="stock-label">
                      {{ DailyNotesContent.stockRecommendation.potentialUpside }}
                    </h4>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="overview">
         <h5 class="sub-title-page">
                {{ DailyNotesContent.articleTitle }}
              </h5>
                 <bullMeter
                :slider="ConvertValue(DailyNotesContent.slider)"
                v-if="DailyNotesContent.showBullMeter == 'True'"
              />
               <p
                class="text-muted text-ellipsis--2"
                v-html="DailyNotesContent.stockRecommendation.article"
              >
               
              </p>
              <a href="javascript:void(0)" @click="ViewFullResearch(DailyNotesContent)"
                >Read full research <i class="bi bi-arrow-right"></i>
              </a>
              <div class="button-container">
                <b-button class="glob-btn btn" ref="btn-morningPrimer" v-b-modal.modal-xl>
                  Morning Primer</b-button
                >
                <b-button class="glob-btn btn" v-b-modal.marketrecap>
                  Market Recap</b-button
                >
                <b-button class="glob-btn btn" v-b-modal.marketSnapshot>
                  Market Snapshots</b-button
                >
              </div>

              <b-modal
                id="modal-xl"
                size="xl"
                title="Extra Large Modal"
                v-model="marketPrimerModalShow"
                @hidden="GetMarketRecapDaily"
              >
                <div class="text-right">
                  <i
                    class="bi bi-x pointer m-4"
                    style="font-size: 2em"
                    @click="marketPrimerModalShow = !marketPrimerModalShow"
                  ></i>
                </div>
                <MorningPrimer />
                <img src="../../assets/Images/wave.svg" class="svg-footer" />
              </b-modal>

              <b-modal
                id="marketrecap"
                size="xl"
                title="Extra Large Modal"
                v-model="marketRecapModalShow"
              >
                <div class="text-right">
                  <i
                    class="bi bi-x pointer m-4"
                    style="font-size: 2em"
                    @click="marketRecapModalShow = !marketRecapModalShow"
                  ></i>
                </div>

                <MarketRecap />
                <img src="../../assets/Images/wave.svg" class="svg-footer" />
              </b-modal>

              <b-modal
                id="marketSnapshot"
                size="xl"
                title="Extra Large Modal"
                v-model="marketSnapshotModalShow"
              >
                <div class="text-right">
                  <i
                    class="bi bi-x pointer m-4"
                    style="font-size: 2em"
                    @click="marketSnapshotModalShow = !marketSnapshotModalShow"
                  ></i>
                </div>

                <MarketSnapshot />
                <img src="../../assets/Images/wave.svg" class="svg-footer" />
              </b-modal>
            </div>
          </div>
        </div>

         <div class="col-lg-8 col-md-12 col-12" v-if="isDaiyNotesLoading== false">
        <b-skeleton width="80%" ></b-skeleton>
        <b-skeleton width="30%" ></b-skeleton>
        <br>
         <b-skeleton-img no-aspect height="100px" width="70%"></b-skeleton-img>
         <br>
        <b-skeleton width="30%" ></b-skeleton>
        <b-skeleton width="80%" ></b-skeleton>
        <b-skeleton width="90%" ></b-skeleton>
        <b-skeleton width="90%" ></b-skeleton>
        <b-skeleton width="100%" ></b-skeleton>
        <br>
          <b-skeleton width="30%" ></b-skeleton>
          <div class="d-flex align-items-center">
          <b-skeleton type="button" class="m-1"></b-skeleton>
          <b-skeleton type="button" class="m-1"></b-skeleton> 
          <b-skeleton type="button" class="m-1"></b-skeleton>
          </div>
        </div>
        <div class="col-12 col-md-12 col-lg-4">
          <div class="p-3">
            <b-skeleton-img
              no-aspect
              height="200px"
              v-if="isDataLoaded == true"
            ></b-skeleton-img>
            <h5 class="sub-title-page">Philstocks Forecast</h5>
            <table class="table secondary-table">
              <tbody>
                <tr
                  v-for="(forecastItem, index) in PageContent.philstocksForecast.content"
                  :key="index"
                >
                  <td class="w-50 text-left">
                    <b> {{ forecastItem.title }}</b>
                  </td>
                  <td class="w-50 text-right">
                    {{ forecastItem.content }}
                  </td>
                </tr>
              </tbody>
            </table>

            <a
              href="javascript:void(0)"
              @click="ViewPhilstocksForecast(PageContent.philstocksForecast.date)"
              >Read full research <i class="bi bi-arrow-right"></i>
            </a>

            <h5 class="sub-title-page">Watch Now</h5>
            <div class="row">
              <div class="col">
                <div class="featured-video-frame">
                  <div
                    class="featured-video"
                    v-html="PageContent.featuredVideo.url"
                  ></div>
                </div>
                <b-skeleton-img v-if="isDataLoaded == true"></b-skeleton-img>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />

      <div class="row" v-if="isInvesttorsNeedToKnowLoading == true">
        <div class="col">
          <h5 class="sub-title-page">Investors' Need to Know</h5>
          <div class="row">
            <div class="col flex-container d-flex justify-content-start">
              <div
                class="flex-box"
                v-for="(investorsToKnowItem, index) in generateList(investorsNeedToKnow)[
                  InvestorsNeedToKnowCurrentPage - 1
                ]"
                :key="index"
              >
                <b-skeleton-img v-if="isDataLoaded == true"></b-skeleton-img>
                <div @click="ViewLink(investorsToKnowItem.link)">
                  <span class="badge-new" v-if="investorsToKnowItem.isLatest == true"
                    >NEW</span
                  >
                  <img
                    :src="'data:image/svg+xml;base64,' + investorsToKnowItem.image"
                    class="img-responsive"
                  />

                  <p class="investor-title">{{ investorsToKnowItem.title }}</p>
                  <p class="text-muted">
                    {{ investorsToKnowItem.description }}
                  </p>
                  <span class="text-muted">{{
                    FormatDate(investorsToKnowItem.date)
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

        <div class="row mt-3 mb-5" v-if="isInvesttorsNeedToKnowLoading == false">
        <div class="col-lg-2 col-md-6 col-6 mb-3">
             <b-skeleton-img no-aspect height="200px"></b-skeleton-img>
        </div>
          <div class="col-lg-2 col-md-6 col-6 mb-3">
             <b-skeleton-img no-aspect height="200px"></b-skeleton-img>
        </div>
          <div class="col-lg-2 col-md-6 col-6 mb-3">
             <b-skeleton-img no-aspect height="200px"></b-skeleton-img>
        </div>
          <div class="col-lg-2 col-md-6 col-6 mb-3">
             <b-skeleton-img no-aspect height="200px"></b-skeleton-img>
        </div>
          <div class="col-lg-2 col-md-6 col-6 mb-3">
             <b-skeleton-img no-aspect height="200px"></b-skeleton-img>
        </div>
          <div class="col-lg-2 col-md-6 col-6 mb-3">
             <b-skeleton-img no-aspect height="200px"></b-skeleton-img>
        </div>
      </div>

      <div class="d-flex justify-content-center mt-5" v-if="isInvesttorsNeedToKnowLoading == true">
        <b-pagination
          size="lg"
          v-model="InvestorsNeedToKnowCurrentPage"
          :total-rows="generateList(investorsNeedToKnow).length"
          :per-page="InvestorsNeedToKnowPerPage"
          v-if="generateList(investorsNeedToKnow).length > perPage"
        ></b-pagination>
      </div>

      <div class="row mt-5">
        <div class="col-lg-6 col-md-12 col-12 mt-2 mb-3" v-if="isTsupitHeroLoading == true">
          <div class="container-corner">
            <h3><b>TsupitHero's Corner (Short-term)</b></h3>
            <h4>{{ TsupitHerosCorner.title }}</h4>
            <span class="text-muted">
              Posted on
              {{ FormatDate(TsupitHerosCorner.date) }}
            </span>
            <h5 class="sub-title-page mt-5">Action Plan</h5>
            <div style="height: 250px" class="child-selector">
              <p
                class="mt-2 mb-5 text-muted text-ellipsis--2"
                v-html="TsupitHerosCorner.stockRecommendations.article"
              >
              </p>
            </div>
            <div
              class="d-flex align-items-center d-inline flex-wrap"
              v-if="TsupitHerosCorner.stocksOnFocus.length != 0"
            >
              <h5><b>Stocks on Focus:</b></h5>
              <div
                v-for="(Stocks, index) in TsupitHerosCorner.stocksOnFocus"
                :key="index"
              >
                <h5>
                  &nbsp;<b>{{ Stocks.stock }}</b
                  >&nbsp;
                </h5>
              </div>
            </div>
            <a href="javascript:void(0)" @click="ViewLink(TsupitHerosCorner.reportLink)"
              >Read full research <i class="bi bi-arrow-right"></i>
            </a>

            <div class="mt-5">
              <h5 class="sub-title-page text-center">Stock Recommendation</h5>
              <div class="limit-table">
                <table class="table secondary-table table-bordered">
                  <thead>
                    <tr class="text-center">
                      <th>Stock</th>
                      <th>Entry Price</th>
                      <th>Target Price</th>
                      <th>Potential Upside</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(stockRecoItem, index) in StockRecoList(
                        TsupitHerosCorner.stockRecommendationList
                      )"
                      :key="index"
                    >
                      <td class="w-25 text-left table-td-strong">
                        {{ stockRecoItem.stockSymbol }}
                      </td>
                      <td class="w-25 text-right">
                        {{ stockRecoItem.entryPrice }}
                      </td>
                      <td class="w-25 text-right">
                        {{ stockRecoItem.targetPrice }}
                      </td>
                      <td class="w-25 text-right">
                        {{ stockRecoItem.potentialUpside }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <b-skeleton-table
                :rows="5"
                :columns="4"
                :table-props="{ bordered: true, striped: true }"
                v-if="isDataLoaded == true"
              ></b-skeleton-table>

              <!-- <router-link to="/TsupitHeroCorner">
                Other Recommendation
              </router-link> -->
            </div>
          </div>
        </div>

         <div class="col-lg-6 col-md-12 col-12" v-if="isTsupitHeroLoading == false">
              <b-skeleton-img no-aspect height="400px"></b-skeleton-img>
        </div>
        
        <div class="col-lg-6 col-md-12 col-12 mt-2 mb-3" v-if="isKapitmansCorner == true">
          <div class="container-corner">
            <h3><b>KapitMan's Corner (Long-term)</b></h3>
            <h4>
              {{ KapitmansCorner.title }}
            </h4>
            <span class="text-muted">
              Posted on
              {{ FormatDate(KapitmansCorner.date) }}</span
            >
            <h5 class="sub-title-page mt-5">Action Plan</h5>
            <!-- distribute equal height -->
            <div style="height: 250px" class="child-selector">
              <p
                class="mt-2 mb-5 text-muted text-ellipsis--2"
                v-html="KapitmansCorner.stockRecommendations.article"
              >
              </p>
            </div>

            <div
              class="d-flex align-items-center d-inline flex-wrap"
              v-if="KapitmansCorner.stocksOnFocus.length != 0"
            >
              <h5><b>Stocks on Focus:</b></h5>
              <div v-for="(Stocks, index) in KapitmansCorner.stocksOnFocus" :key="index">
                <h5>
                  &nbsp;<b>{{ Stocks.stock }}</b
                  >&nbsp;
                </h5>
              </div>
            </div>

            <a href="javascript:void(0)" @click="ViewLink(KapitmansCorner.reportLink)"
              >Read full research <i class="bi bi-arrow-right"></i>
            </a>
            <div class="mt-5">
              <h5 class="sub-title-page text-center">Stock Recommendation</h5>
              <div class="limit-table">
                <table class="table secondary-table table-bordered">
                  <thead>
                    <tr class="text-center">
                      <th>Stock</th>
                      <th>Entry Price</th>
                      <th>Target Price</th>
                      <th>Potential Upside</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(stockRecommendationItem, index) in StockRecoList(
                        KapitmansCorner.stockRecommendationList
                      )"
                      :key="index"
                    >
                      <td class="w-25 text-left table-td-strong">
                        {{ stockRecommendationItem.stockSymbol }}
                      </td>
                      <td class="w-25 text-right">
                        {{ stockRecommendationItem.entryPrice }}
                      </td>
                      <td class="w-25 text-right">
                        {{ stockRecommendationItem.targetPrice }}
                      </td>
                      <td class="w-25 text-right">
                        {{ stockRecommendationItem.potentialUpside }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <b-skeleton-table
                :rows="5"
                :columns="4"
                :table-props="{ bordered: true, striped: true }"
                v-if="isDataLoaded == true"
              ></b-skeleton-table>
              <!-- <router-link to="/KapitsmanCorner">
                Other Recommendation
              </router-link> -->
            </div>
          </div>
        </div>

         <div class="col-lg-6 col-md-12 col-12" v-if="isKapitmansCorner == false">
              <b-skeleton-img no-aspect height="400px"></b-skeleton-img>
        </div>
      </div>

      <div class="row mt-5">
        <div class="col p-4">
          <div class="learn-title mb-3">
            <h5 class="sub-title-page">Learn</h5>
          </div>

          <div class="row" v-for="(playlist, index) in VideoContent" :key="index">
            <div
              class="col-lg-3 col-md-12 col-12"
              v-for="(playlistItem, index) in playlist"
              :key="index"
            >

              <div v-for="(videoItem, index) in filteredPlayList(playlistItem.subPlaylist)" :key="index" class="learn-group-list">

                <h6>
                  <br />
                  <b>{{ videoItem.subPlaylistTitle }}</b>
                </h6>
                <ul
                  class="learn-list"
                  v-for="(item, index) in filteredList(videoItem.videos)"
                  :key="index"
                >
                  <!-- <li></li> -->
                  <li @click="playVideos(item.videoTitle)">
                    {{ item.videoTitle }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col p-4">
          <div class="learn-title">
            <h5 class="sub-title-page">Other Reports</h5>
          </div>
          <div class="row">
            <div
              class="col-lg-3 col-md-3 col-12"
              v-for="(otherReports, index) in PageContent.otherReportsList"
              :key="index"
            >
              <ul class="learn-list">
                <li @click="ViewLink(otherReports.source)">
                  {{ otherReports.title }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <br />
      <a target="_blank" href="https://news.philstocks.ph/?vcode"> </a>
      <i style="margin-left: 0.7em"
        >To access the old Research Tab, click
        <a target="_blank" href="https://news.philstocks.ph/?vcode">here </a></i
      >
    </div>

    <Footer />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { cookiesHandler } from "../../utils/cookie_handler.js";

import navHeader from "../ResearchPages/NavHeader";
import Footer from "../ResearchPages/Footer";
import moment from "moment";
//import LoginPage from "../ResearchPages/LoginPage";
// import SkeletonLoading from "../ResearchPages/SkeletonLoading";
import MarketRecap from "../ResearchPages/ReportsPages/MarketRecap.vue";
import MorningPrimer from "../ResearchPages/ReportsPages/MorningPrimer.vue";
import SkeletonStructureHome from "../../components/ResearchPages/SkeletonStructureHome";
import MarketSnapshot from "../ResearchPages/ReportsPages/MarketSnapshot.vue";
import bullMeter from "./BullMeter/BullMeter.vue";
export default {
  mixins: [cookiesHandler],
  components: {
    navHeader,
    MarketRecap,
    MorningPrimer,
    MarketSnapshot,
     bullMeter,
    // SkeletonLoading,
    SkeletonStructureHome,
    Footer,
  },

  data() {
    return {
      showModalM: false,
      isLatest: false,
      hasMorningPrimer: false,
      isDataLoaded: false,
      perPage: 1,
      currentPage: 1,
      morningPrimerCurrentPage: 1,
      marketRecapModalShow: false,
      marketSnapshotModalShow: false,
      marketPrimerModalShow: false,
      InvestorsNeedToKnowCurrentPage: 1,
      InvestorsNeedToKnowPerPage: 1,
      today: moment().format("L"),
      time: moment().format("LT"),
      isDaiyNotesLoading:false,
      isInvesttorsNeedToKnowLoading:false,
      isTsupitHeroLoading:false,
      isKapitmansCorner:false,
    };
  },
  validations: {},
  computed: {
    ...mapState({
      PageContent: (state) => state.philstocksResearch.HomeContent,
      TsupitHerosCorner: (state) => state.philstocksResearch.tsupitHerosCornerContent,
      KapitmansCorner: (state) => state.philstocksResearch.kapitsmanCornerContent,
      VideoContent: (state) => state.philstocksResearch.LearnContent,
      playedVideo: (state) => state.philstocksResearch.playedVideo,
      DailyNotesContent: (state) => state.philstocksResearch.dailyNotesContent,
      investorsNeedToKnow: (state) => state.philstocksResearch.investorsNeedToKnow,
    }),
  },

  methods: {
    homePage() {
      this.$gtag.event("homePage", { method: "Google" });
    },
     ConvertValue(data) {
      var value = parseInt(data);
      return value;
    },
    FilterSubPlaylist(data) {
      if (data != undefined) {
        var list = data.slice(0, 2);
        return list;
      }
    },
    filteredList(data) {
      var list = data.slice(0, 5);
      return list;
    },
     filteredPlayList(data) {
      if(data != undefined)
      var list = data.slice(0, 2);
      return list;

    },
    async showMorningPrimer() {
      var morningPrimer = this.getCookie("MorningPrimer");

      if (morningPrimer) {
        await this.GetMarketRecapDaily();
      } else {
        var payload = {
          name: "MorningPrimer",
          value: true,
        };
        this.createCookie(payload);
        this.$bvModal.show("modal-xl");
      }
    },
    showMarketRecap() {
      var marketRecap = this.getCookie("MarketRecap");
      if (!marketRecap) {
        var payload = {
          name: "MarketRecap",
          value: true,
        };
        this.createCookie(payload);
        this.$bvModal.show("marketrecap");
      }
    },
    FormatDate(date) {
      var result = "";
      if (date == "0001-01-01T00:00:00") {
        result = "--";
      } else {
        result = moment(date).format("MMMM DD, YYYY");
      }
      return result;
    },
    ViewPhilstocksForecast(data) {
      this.$store.dispatch("philstocksResearch/GetPhilstocksForecast", data);
      this.$router.push("/Reports/ForecastReport?date=" + data);
    },

    ViewFullResearch(data) {
      if (data.isDailyNotes == true) {
        this.$store.dispatch("philstocksResearch/GetDailyNotes", data.date);
        this.$router.push("/Reports/DailyNotes?date=" + data.date);
      } else {
        this.$store.dispatch("philstocksResearch/GetWeeklyNotes", data.date);
        this.$router.push("/Reports/WeeklyNotes?date=" + data.date);
      }
    },

    ViewLink(data) {
      window.location.href = data;
    },
    playVideos(data) {
      this.$router.push("/Learn?keyword=" + data);
      this.$store.dispatch("philstocksResearch/GetLearnVideo", data);
    },

    async GetHomeContent() {
      var isResponseError = false;
      this.isDataLoaded = true;
      var _this = this;
      await this.$store
        .dispatch("philstocksResearch/GetHomeContent")
        .catch(function (error) {
          console.log(error);
          _this.isDataLoaded = false;

          isResponseError = false;
        });

      if (!isResponseError) {
        _this.isDataLoaded = false;
      }
    },
     async GetDailyNotesContent() {
      var isResponseError = false;
      this.isDataLoaded = true;
      var _this = this;
      await this.$store
        .dispatch("philstocksResearch/GetHomeContent")
        .catch(function (error) {
          console.log(error);
          _this.isDataLoaded = false;

          isResponseError = false;
        });

      if (!isResponseError) {
        _this.isDataLoaded = false;
      }
    },


    
    async GetMorningPrimerDaily() {
      var _this = this;
      var payload = {
        DateFrom: moment().format("MM/DD/YYYY"),
        DateTo: moment().format("MM/DD/YYYY"),
      };
      await this.$store
        .dispatch("philstocksResearch/GetMorningPrimerArchive", payload)
        .then(function (response) {
          if (response.morningPrimerList.length != 0) {
            setTimeout(function () {
              _this.showMorningPrimer();
            }, 2000);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    async GetMarketRecapDaily() {
      var _this = this;
      var payload = {
        DateFrom: moment().format("MM/DD/YYYY"),
        DateTo: moment().format("MM/DD/YYYY"),
      };
      await this.$store
        .dispatch("philstocksResearch/GetMarketRecapArchive", payload)
        .then(function (response) {
          if (response.marketRecapList.length != 0) {
            setTimeout(function () {
              _this.showMarketRecap();
            }, 2000);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    StockRecoList(data) {
      const list = data;
      const size = 5;
      const items = list.slice(0, size);
      return items;
    },

    generateList(data) {
      var result = [];
      var list = 5;
      if (data == undefined) {
        result = [];
      } else {
        result = data.reduce((resultArray, item, index) => {
          const listIndex = Math.floor(index / list);

          if (!resultArray[listIndex]) {
            resultArray[listIndex] = []; // start a new list
          }

          resultArray[listIndex].push(item);

          return resultArray;
        }, []);
      }
      return result;
    },

    async fethcDailyNotesContentLatest() {
       var _this = this;
      await this.$store
        .dispatch("philstocksResearch/GetDailyNotesContent").then(function (response) {
      if(response.status == 200){
          _this.isDaiyNotesLoading = true;
      }
  
        })
        .catch(function (error) {
          console.log(error);
          _this.isDaiyNotesLoading = false;
        });
    },

 async fethInvestorsNeedToknow() {
       var _this = this;
      await this.$store
        .dispatch("philstocksResearch/GetInvestorsNeedtoKnow").then(function (response) {
      if(response.status == 200){
          _this.isInvesttorsNeedToKnowLoading = true;
      }
  
        })
        .catch(function (error) {
          console.log(error);
          _this.isInvesttorsNeedToKnowLoading = false;
        });
    },
    async fetchTsupitHeroCorner() {
            var _this = this;
      await this.$store
        .dispatch("philstocksResearch/GetTsupitHeroContent").then(function (response) {
      if(response.status == 200){
          _this.isTsupitHeroLoading = true;
   }
        })
        .catch(function (error) {
          console.log(error);
          _this.isTsupitHeroLoading = false;
        });
    },

     async fetchKapitmansCorner() {
            var _this = this;
      await this.$store
        .dispatch("philstocksResearch/GetKapitsmanContent").then(function (response) {
      if(response.status == 200){
          _this.isKapitmansCorner = true;
   }
        })
        .catch(function (error) {
          console.log(error);
          _this.isKapitmansCorner = false;
        });
    },

  },
  async mounted() {
  await this.GetHomeContent();
  await this.fethcDailyNotesContentLatest();
  await this.fetchTsupitHeroCorner();
  await this.fetchKapitmansCorner();
  await this.$store.dispatch("philstocksResearch/GetLearnContent");
  await this.fethInvestorsNeedToknow();
  await this.$store.dispatch("philstocksResearch/GetLatestMorningPrimerContent");
  await this.$store.dispatch("philstocksResearch/GetLatestMarketRecapContent");
  await this.$store.dispatch("philstocksResearch/GetLatestMarketSnapshotContent");
  await this.GetMorningPrimerDaily();

 
  },   

};
</script>

<style></style>
